<template>
  <div>
    <div>{{ $t("dashboard.report_performance") }}</div>
    <div style=" height: 300px" ref="chartdiv"></div>
  </div>
</template>
  
<script>
import axios from "axios";
import util from "../../util";
import dayjs from "dayjs";

import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import {mapState} from "vuex"
export default {
  name: "UnresolvedReports_Gauge",
  data() {
    return {
      data: [],
      evaluated: 6,
      total: 123,
    };
  },
  methods: {
    async loadData() {
      const customerId = JSON.parse(localStorage.getItem('user')).customerId
      var urlString = `${process.env.VUE_APP_APIURL}/dashboard/reports`;
      let resp = await axios.get(urlString);
      if (resp.status == 200) {

        this.total = resp.data.data.total;
        this.evaluated = resp.data.data.detectionReports.filter((x) => x.isAnswered === true).length
        let e = parseInt((this.evaluated / this.total) * 100);
        let r = 100 - e;
        if (r != 0) {
          this.series.data.setAll([
            { sector: "Evaluated", size: e },
            { sector: "Not Evaluated", size: r },
          ]);
        } else {
          this.series.data.setAll([{ sector: "Evaluated", size: e }]);
        }

        // handle if no data
        if (!this.total) {
          this.noDataLabel.set("text", this.$t("common.noData"));
        } else {
          this.label.set("text", `${this.evaluated}/${this.total}`);
        }
        // Make stuff animate on load
      } else {
        console.log("Error loading data");
      }
    },
  },
  computed: {
    telemetryName() {
      if (this.telemetry) {
        return this.telemetry;
      }
      return "";
    },
    friendlyDate() {
      if (this.date) {
        let d = dayjs().diff(dayjs(this.date, "YYYY-MM-DDTHH:mm:ss.SSSZ"), "m");
        return `${d} ${this.$t("common.minute")} ${this.$t("common.ago")}`;
      }
    },
    path() {
      if (this.point) {
        return util.treeHelper.pointIdToPath(this.flatTree,this.point);
      }
    },
    ...mapState("tree",["flatTree"])
  },
  mounted() {
    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    let root = am5.Root.new(this.$refs.chartdiv);

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/
    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        innerRadius: 50,
        layout: root.verticalLayout,
      })
    );

    // Create series
    // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "size",
        categoryField: "sector",
      })
    );
    this.series = series;
    series.labels.template.set("forceHidden", true);
    series.ticks.template.set("forceHidden", true);

    // Add label
    let label = root.tooltipContainer.children.push(
      am5.Label.new(root, {
        x: am5.p50,
        y: am5.p50,
        centerX: am5.p50,
        centerY: am5.p50,
        fill: am5.color(0x000000),
        fontSize: 25,
      })
    );
    this.label = label;

    let noDataLabel = root.tooltipContainer.children.push(
      am5.Label.new(root, {
        x: am5.p50,
        y: am5.p50,
        centerX: am5.p50,
        centerY: am5.p50,
        fill: am5.color("#909399"),
        fontSize: 15,
      })
    );

    this.noDataLabel = noDataLabel;
    this.loadData();
  },

  beforeDestroy() {
    if (this.root) {
      this.root.dispose();
    }
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@keyframes growProgressBar {

  0%,
  33% {
    --pgPercentage: 0;
  }

  100% {
    --pgPercentage: var(--value);
  }
}

@property --pgPercentage {
  syntax: "<number>";
  inherits: false;
  initial-value: 0;
}

div[role="progressbar"] {
  --size: 12rem;
  --fg: #369;
  --bg: #def;
  --pgPercentage: var(--value);
  animation: growProgressBar 3s 1 forwards;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: radial-gradient(closest-side,
      white 80%,
      transparent 0 99.9%,
      white 0),
    conic-gradient(var(--fg) calc(var(--pgPercentage) * 1%), var(--bg) 0);
  font-family: Helvetica, Arial, sans-serif;
  font-size: calc(var(--size) / 5);
  color: var(--fg);
}

div[role="progressbar"]::before {
  counter-reset: percentage var(--value);
  content: counter(percentage) "%";
}
</style>